<template>
    <form class="edit-order-components-page-form form-horizontal" @submit.prevent="submit()">
        <div class="form-group">
            <label for="" class="col-sm-4" style="color:#0f69b4;">Rotulos</label>
            <div class="col-sm-8">
                
            </div>
        </div>
        <div  class="form-group">
            <div class="col-sm-12" >
                <table class="table" width="90%">
                    <thead>
                        <th style="text-align: center;width:5%">Order</th>
                        <th style="text-align: center;width:75%">Titulos</th>
                        <th style="text-align: center;width:10%">Acciones</th>
                    </thead>
                    <tbody>
                        <tr v-for="(value,index) in data.labelsList" :key="value.orden" v-bind:class="{'bg-danger' : value.status == 0}">
                            <td>{{value.orden}}</td>
                            <td>{{value.title}}</td>
                            <td style="text-align: center">
                                <a href="#" @click.prevent="up(index)" title="Subir"><i class="material-icons">arrow_upward</i></a>
                                <a href="#"  @click.prevent="down(index)" title="Bajar"><i class="material-icons">arrow_downward</i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
         <div  class="form-group">
            <div class="col-sm-12 text-right">
                <a :href="'backend/fichas/'+page.id+'/edit'" class="btn btn-default"><i class="material-icons">arrow_back</i> Seguir Editando</a>
                <button v-show="changeOrder || changeAlias" class="btn btn-primary"  type="submit" >Guardar Cambios</button>
            </div>
        </div>
        
        <div class="form-group">
            <label for="" class="col-sm-2 control-label" style="color:#0f69b4;">Previsualización</label>
            <div class="col-sm-12">
                <div id="page" class="ficha">
                    <div class="page-content">
                        <div  class="accordion accordion-page" id="accordionpage">
                            <div  class="card"  v-for="(value,index) in data.labelsList" :key="value.orden" v-if="value.status == 1" >
                                <a  class="btn btn-link collapsed" href="javascript:void(0);" data-toggle="collapse" :data-target="'#collapse' + index" aria-expanded="true" :aria-controls="'collapse' + index">
                                    <div class="card-header" id="headingtwo">
                                        <h2 class="mb-0" id="beneficiaries">{{value.title}} </h2>
                                        <span>Conocer más</span>
                                    </div>
                                </a>
                                <div :id="'collapse' + index" class="collapse" aria-labelledby="headingtwo" data-parent="#accordionpage">
                                    <div class="card-body" v-if="value.name != 'howto'" v-html="'<br/>'+value.description">
                                        {{ value.description }}
                                    </div>
                                    <div class="card-body" v-else>
                                        <div class="howto main-tabs">
                                            <div class="tabs-container" style="overflow-x: hidden;">
                                                <ul class="nav nav-tabs" role="tablist" >
                                                    <li v-if="page.online" role="presentation">
                                                        <a href="#online" aria-controls="online" role="tab" data-toggle="tab" >
                                                            <i class="material-icons">devices</i>En línea
                                                        </a>
                                                    </li>
                                                    <li v-if="page.office" role="presentation">
                                                        <a href="#office" aria-controls="office" role="tab" data-toggle="tab"  >
                                                            <i class="material-icons">store</i>En oficina
                                                        </a>
                                                    </li>
                                                    <li v-if="page.phone" role="presentation">
                                                        <a href="#phone" aria-controls="phone" role="tab" data-toggle="tab" >
                                                            <i class="material-icons">phone</i>Telefónico
                                                        </a>
                                                    </li>
                                                    <li v-if="page.mail" role="presentation">
                                                        <a href="#mail" aria-controls="mail" role="tab" data-toggle="tab"  >
                                                            <i class="material-icons">mail</i>Correo
                                                        </a>
                                                    </li>
                                                    <li v-if="page.consulate" role="presentation">
                                                        <a href="#consulate" aria-controls="mail" role="tab" data-toggle="tab" >
                                                            <i class="material-icons">store</i>Consulado
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="tab-content">
                                                <div role="tabpanel" class="tab-pane" id="online" v-html="page.online_guide">
                                                    <div class="visible-print-block"><strong>- Instrucciones Trámite en línea</strong></div>
                                                    {{page.online_guide}}
                                                </div>
                                                <div role="tabpanel" class="tab-pane" id="office" v-html="page.office_guide">
                                                    <div class="visible-print-block"><strong>- Instrucciones Trámite en Sucursal</strong></div>
                                                    {{page.office_guide}}
                                                </div>
                                                <div role="tabpanel" class="tab-pane" id="phone" v-html="page.phone_guide">
                                                    <div class="visible-print-block"><strong>- Instrucciones contacto telefónico</strong></div>
                                                    {{page.phone_guide}}
                                                </div>
                                                <div role="tabpanel" class="tab-pane" id="mail" v-html="page.mail_guide">
                                                    <div class="visible-print-block"><strong>- Instrucciones trámite por Email</strong></div>
                                                    {{page.mail_guide}}
                                                </div>
                                                <div role="tabpanel" class="tab-pane" id="consulate" v-html="page.consulate_guide">
                                                    <div class="visible-print-block"><strong>- Instrucciones trámite en el Consulado</strong></div>
                                                    {{page.consulate_guide}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </form>
</template>
<script>
export default {
    data:function(){
        const labels = _.cloneDeep(this.labels);
        const pages = _.cloneDeep(this.page);

        return{
            data:{
                labelsList:labels,
                pages:pages,
            },
            changeOrder:false,
            changeAlias:false,
            errors:{},
        }
    },
    props:['page','labels'],
    methods:{
        up:function(from){
            if(from == 0)
                return;

            var to = from - 1;
            var pos = 1 ;

            this.data.labelsList.splice(to, 0, this.data.labelsList.splice(from, 1)[0]);

            this.data.labelsList.forEach(c => {
                c.orden = pos;
                pos++;
            });

            this.isDifferent();
        },
        down: function(from){
            var to = from + 1;
            var pos = 1 ;

            this.data.labelsList.splice(to, 0, this.data.labelsList.splice(from, 1)[0]);

            this.data.labelsList.forEach(c => {
                c.orden = pos;
                pos++;
            });

            this.isDifferent();
        },
        isDifferent:function(){
            var self = this;
            self.changeOrder = false;

            this.data.labelsList.forEach(function(component){
                var componentOrigin = self.labels.find(e => e.name ==  component.name);
                
                if(component.orden != componentOrigin.orden)
                    self.changeOrder = true;                
            });
        },
        submit: function(){
            var self = this;
            this.errors={};

            this.$confirm('Los cambios se asociaran a una versión que debe ser publicada para visualizar los cambios,¿Desea guardar los cambios?','Atención',{
                confirmButtonText:'Grabar',
                cancelButtonText: 'Cancelar',
                type:'warning'
            }).then(()=>{
                axios({
                    url:'backend/fichas/' + self.page.id + '/editar_orden_pages',
                    method: 'PUT',
                    data:self.data,
                }).then(function(response){
                    // console.log(response);
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    self.errors = error.response.data.errors;
                });
            }).catch();
        },
    }
}
</script>
<style lang="scss" scoped>
    .page-content {
        color: #000 !important;
    }
    .page-content .CardDescription p {
        font-weight: 500 !important;
    }
    .page-content p {
        color: #4A4A4A;
        font-family: "Roboto";
        font-size: 16px;
        font-weight: 400;
    }
    body, p, span {
        font-size: 16px;
    }
    .CardDescription .message-reloj {
        background: url(/images/warning-ico.svg?af6765f…);
        background-repeat: no-repeat;
        background-position: top left;
        background-size: 45px 40px;
    }
    .ficha .message {
        border: 1px solid #0f69b4 !important;
        background-color: #e5f1ff !important;
        border-radius: 5px !important;
        padding: 20px 40px 20px 60px !important;
    }
    .message {
        color: #4A4A4A;
        font-family: "Roboto";
        font-size: 16px;
        font-weight: 400;
        border: 1px solid #d5d5d5;
        padding: 10px 40px 10px 60px;
    }
    .ficha .page-content .accordion-page {
        margin-top: 20px !important;
    }
    .ficha .page-content .accordion-page .card {
        background-image: url(/images/bg-cards.jpg) !important;
        background-repeat: no-repeat !important;
        background-repeat-y: repeat !important;
        background-position: center left !important;
        background-size: 12px auto !important;
    }
    .card {
        font-family: 'Roboto';
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: border-box;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 10px;
        padding: 18px;
        padding-top: 12px;
        margin-bottom: 25px;
        font-weight: initial;
        overflow: hidden;
    }
    .accordion-page .card a.btn-link {
        padding: 0px;
    }
    .ficha .page-content .accordion-page .card a.btn-link .card-header {
        border-bottom: 1px solid transparent !important;
    }
    .accordion-page .card a.btn-link .card-header {
        margin-top: 11px;
    }
    .accordion-page .card a.btn-link .card-header h2 {
        float: left;
    }
    .ficha .page-content .accordion-page .card a.btn-link .card-header span {
        float: right !important;
        color: #0f69b4 !important;
        font-size: 14px !important;
        padding-top: 16px !important;
    }
</style>